// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Button } from 'antd';
import React, { ReactElement, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';

import './DisplayEntityInfo.scss';

export interface EntityInfoType {
    label?: ReactNode;
    danger?: boolean;
    count?: number;
    stats?: { count: number; color: string; description?: string }[];
    link?: string;
}

type DisplayEntityInfoProps = EntityInfoType;

const DisplayEntityInfo = ({ label, danger = false, count, stats, link }: DisplayEntityInfoProps): ReactElement => {
    const history = useHistory();

    const Content = (
        <div
            className={classList('display-entity-info__container', {
                danger: danger,
            })}
        >
            <span>{label}</span>
            <span className="display-entity-info__container-count">{count}</span>
        </div>
    );

    return (
        <div className="display-entity-info">
            {link ? (
                <Button className="display-entity-info__link" type="link" onClick={(): void => history.push(link)}>
                    {Content}
                </Button>
            ) : (
                Content
            )}
            {stats && (
                <div className="display-entity-info__count">
                    {stats.map(({ count, color, description = '' }, index) => (
                        <THTooltip title={`${count} ${description}`} key={`count-${index}`} placement="bottom">
                            <span
                                className="display-entity-info__count-block"
                                style={{ flex: count, backgroundColor: color }}
                            />
                        </THTooltip>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DisplayEntityInfo;
